import client from '../session/apiClient';

export default {
    getAppleCategories: () => {
        return client.get("/locations/appleCategories?limit=10000")
            .then(resp => {
                return resp.data
            })
    }
};
